<div id="library-rules" class="watermark">
  <div class="container-fluid px-lg-5 py-4">
    <div class="row">
      <div class="col-12">
        <h2 class="title mb-4">General Rules</h2>

        <p class="inner-lead">
          The main purpose of these rules is to safeguard the common interest of all users and to enable the
          library to carry out its functions as efficiently as possible.
        </p>

        <ul class="inner-lead">
          <li>Enter your name and sign in the register kept at the entrance of library before entering its premises.</li>
          <li>Use of mobile phones in the library is strictly prohibited.</li>
          <li>Students are allowed inside the library only on the production of their valid Identity Cards.</li>
          <li>No personal belongings are allowed inside the library.</li>
          <li>Show the books and other materials which are being taken out of the library to staff at the entrance counter.</li>
          <li>Maintain silence inside the library.</li>
          <li>Users are not allowed to carry eatables inside the library premises.</li>
          <li>The library shall not be responsible for any loss or damage of the personal belongings.</li>
          <li>The Librarian may recall any book from a member at any time and the member shall return the same immediately.</li>
          <li>The borrowing facility can be withdrawn or restricted in case of misbehavior of users for their misuse of the library.</li>
          <li>Strict discipline should be maintained in the library. The position of the chairs and tables should not be changed or displaced.</li>
          <li>No Readers is allowed to sleep in the library premises.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
